<template>
  <div></div>
</template>

<script>
export default {
  name: 'AuthCallback',
};
</script>
